module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Сумма","track":"Amount"}}